export default "__VITE_ASSET__BttJNu_J__"